/**
 * GoToMain, a class to handle the "Go to Main" functionality.
 * Targets .scroll-to-main elements to scroll to the main content.
 */
class GoToMain {
	static setup() {
		document.querySelectorAll('.scroll-to-main').forEach((el) => {
			new GoToMain(el).init();
		});
	}

	constructor(element) {
		this.element = element;
	}

	init() {
		this.element.addEventListener('click', this.handleClick.bind(this));
	}

	handleClick(event) {
		event.preventDefault();

		// 1. Find the parent section
		const parentSection = this.element.closest('.wp-block-qte-theme-section');
		if (!parentSection) {
			console.warn('[GoToMain] no parent .wp-block-qte-theme-section found');
			return;
		}

		// 2. Measure its height + bottom margin
		const style = getComputedStyle(parentSection);
		const marginBottom = parseFloat(style.marginBottom) || 0;
		const totalHeight = parentSection.offsetHeight + marginBottom;

		// 3. Scroll down by that amount
		window.scrollBy({
			top: totalHeight,
			left: 0,
			behavior: 'smooth',
		});
	}
}

// DOM ready check
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	GoToMain.setup();
} else {
	document.addEventListener('DOMContentLoaded', GoToMain.setup);
}
